<template>
    <div class="finale">
        <div class="ribbon-row">
            <div class="ribbon-col">
                <scope-ribbon-feedback></scope-ribbon-feedback>
            </div>
            <div class="ribbon-col">
                <business-ribbon-feedback></business-ribbon-feedback> 
            </div>
        </div>
        <div class="learnapply">
            <h3>Learn and Apply</h3>
            <p>Continue developing your framing accumen by viewing our <a href="https://portal.insightxp.com/portal.html?space=itg" target="_blank">resources to build awareness and hone skills for framing</a>.</p>
        </div>
        <div class="sticky-footer">
            <button @click="replay" class="btn center noselect">Replay</button>
        </div>
        
        <div id="featureBackground" class="confetti"></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { gsap } from '/src/assets/js/gsap'
import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin'
import { Physics2DPlugin } from '/src/assets/js/gsap/Physics2DPlugin'
import axios from 'axios';
import BusinessRibbonFeedback from '@/components/BusinessRibbonFeedback.vue'
import ScopeRibbonFeedback from '@/components/ScopeRibbonFeedback.vue'

var FormData = require('form-data');

export default {
    name: "Complete",
    components : {
        'business-ribbon-feedback' : BusinessRibbonFeedback,
        'scope-ribbon-feedback' : ScopeRibbonFeedback
    },
    computed: {
        ...mapGetters([
            "getState",
            "getUserType",
            "playerSelections",
            "playerSelectionCounts",
            "playerScores",
            "optionValues",
            "maxScores",
            "maxTotal",
            "playerTotal"
        ])
    },
    mounted () {
        gsap.registerPlugin(ScrollToPlugin, Physics2DPlugin);
        this.$parent.appHeight();
        gsap.to(window, {duration: 0.5, scrollTo: 0, delay: .2, ease: "sine.inOut"});
        this.doConfetti();
        this.setEndTime();

        gsap.delayedCall(0.75, this.sendData);
    },
    methods: {
        ...mapActions([
            "setEndTime",
            'reset'
        ]),
        replay() {
            // animate out, then reset, 
            gsap.to('.finale', {autoAlpha: 0, duration: 0.5, ease: "sine.inOut"})
            gsap.delayedCall(0.75, this.reset);
            gsap.delayedCall(1, this.goHome);
        },
        goHome() {
            this.$router.push({ path: "/" });
        },
        sendData () {
            var data = new FormData();
            var payload = JSON.stringify(this.getState);
            data.append('value', payload);

            var config = {
                method: 'post',
                url: `https://engine.insightxp.com/pdata?sim=framing&key=${this.getUserType}`,
                data : data
            };

            axios(config)
                .then(function (response) {
                    // console.log(JSON.stringify(response.data));
                })
                .catch(function (error) {
                    // console.log(error);
                });

        },
        doConfetti() {
            let dots = [],
            bg = document.querySelector("#featureBackground"),
            i, dot;

            // create 80 dot elements and put them in an array
            for (i = 0; i < 80; i++) {
            dot = document.createElement("div");
                dot.setAttribute("class", "dot");
                bg.appendChild(dot);
                dots.push(dot);
            }

            //set the initial position of all the dots, and pick a random color for each from an array of colors
            gsap.set(dots, {
                backgroundColor: "random([#01aded, #f45537, #b4d236, #f08fae, #f5a421])",
                scale: "random(0.1, 0.35)",
                skewX: "random(20, 50)",
                height: "random(10px, 50px)",
                transformOrigin: 'center center',
                x: '50vw',
                y: '-20vh'
            });

            gsap.from('#title, #medal', { autoAlpha: 0, y: 200, ease:'back.out', stagger: { amount: 0.15}, delay: 0.15})

            // create the physics2D animation
            gsap.to(dots, {
                duration: 5,
                rotation: "random(0, 5) * 360 + random(0, 360)",
                physics2D: {
                    velocity: 20,
                    angle: "random(0, 180)",
                    gravity: 50,
                },
                delay: "random(0, 1.5)"
            });
        }
    }
};
</script>